
import React from 'react';
import { Grid3X3, Hand, Image as ImageIcon, Smile } from 'lucide-react';
import { cn } from '@/lib/utils';

interface CanvasPreviewProps {
  className?: string;
}

const CanvasPreview: React.FC<CanvasPreviewProps> = ({ className }) => {
  return (
    <div className={cn("relative w-full max-w-[300px] h-64 mx-auto my-4", className)}>
      {/* Canvas background with grid */}
      <div className="absolute inset-0 bg-black/20 rounded-xl overflow-hidden backdrop-blur-sm border border-primary/20">
        {/* Grid pattern overlay */}
        <div className="absolute inset-0 bg-[#1A1F2C]/80">
          <div className="absolute inset-0 grid grid-cols-4 grid-rows-4">
            {Array.from({ length: 16 }).map((_, i) => (
              <div key={i} className="border border-[#8E9196]/20" />
            ))}
          </div>
        </div>

        {/* Grid icon in top right */}
        <div className="absolute top-3 right-3 bg-black/40 backdrop-blur-sm p-1.5 rounded-full">
          <Grid3X3 size={14} className="text-[#9b87f5]" />
        </div>

        {/* Center image */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-28 h-28 rounded-lg overflow-hidden border-2 border-[#9b87f5]/30">
          <div className="w-full h-full bg-gradient-to-br from-[#7E69AB]/30 to-[#D6BCFA]/30 flex items-center justify-center">
            <ImageIcon size={28} className="text-white/70" />
          </div>
        </div>

        {/* Hand grabbing emoji */}
        <div className="absolute bottom-6 right-10 flex items-end animate-pulse">
          <div className="relative">
            {/* Emoji with outline */}
            <div className="absolute bottom-6 right-3 w-10 h-10 rounded-full bg-[#F97316] border-2 border-[#9b87f5] flex items-center justify-center shadow-lg z-10">
              <Smile size={18} className="text-white" />
            </div>
            {/* Hand icon */}
            <Hand size={32} className="text-[#9b87f5] transform rotate-[30deg]" />
          </div>
        </div>

        {/* Another decorative element */}
        <div className="absolute top-10 left-8 w-8 h-8 rounded-full bg-[#33C3F0] border border-[#9b87f5]/50 flex items-center justify-center">
          <div className="w-4 h-4 rounded-full bg-white/70" />
        </div>
      </div>
    </div>
  );
};

export default CanvasPreview;
